import type { BankApp } from './bankApps';

export type KgsBankId = 'mbank' | 'demir' | 'eldik' | 'bakai';

export interface KgsBankApp extends BankApp {
    readonly id: KgsBankId;
}

// Domain associations make these launch candidates, not verified app launches.
// Keep verification null until each OS passes the device checklist. Visibility
// is independent of verification so these links can be tested from the form.
export const KGS_BANK_APPS: readonly KgsBankApp[] = [
    {
        id: 'mbank',
        name: 'MBANK',
        logo: '/assets/banks/mbank_logo-a4fdd332.svg',
        logoBackground: '#FFFFFF',
        background: '#006C45',
        color: '#FFFFFF',
        sourceUrl: 'https://app.mbank.kg/.well-known/apple-app-site-association',
        evidence: 'domain-association-candidate',
        android: { url: 'https://app.mbank.kg/', verification: null },
        ios: { url: 'https://app.mbank.kg/', verification: null },
    },
    {
        id: 'demir',
        name: 'DemirBank',
        logo: '/assets/banks/demir_logo-9f7d5a1b.svg',
        logoBackground: '#FFFFFF',
        background: '#AC1825',
        color: '#FFFFFF',
        sourceUrl: 'https://retail.demirbank.kg/.well-known/apple-app-site-association',
        evidence: 'domain-association-candidate',
        android: { url: 'https://retail.demirbank.kg/', verification: null },
        ios: { url: 'https://retail.demirbank.kg/', verification: null },
    },
    {
        id: 'eldik',
        name: 'Элдик',
        // Official logo published at eldik.kg/ru (LogoName.b6fb0c6e.png).
        logo: '/assets/banks/kgs/eldik.png',
        logoBackground: '#FFFFFF',
        background: '#1261C4',
        color: '#FFFFFF',
        sourceUrl: 'https://eldik.kg/.well-known/apple-app-site-association',
        evidence: 'domain-association-candidate',
        android: { url: 'https://eldik.kg/', verification: null },
        ios: { url: 'https://eldik.kg/', verification: null },
    },
    {
        id: 'bakai',
        name: 'Бакай',
        logo: '/assets/banks/bakai_logo-5968ab22.avif',
        logoBackground: '#FFFFFF',
        background: '#19417D',
        color: '#FFFFFF',
        // bakai.app publishes bakai://bakai.app/app/dashboard and maps the
        // same path to HTTPS. Its Android/iOS associations cover this route.
        sourceUrl: 'https://bakai.app/',
        evidence: 'domain-association-candidate',
        android: { url: 'https://bakai.app/app/dashboard', verification: null },
        ios: { url: 'https://bakai.app/app/dashboard', verification: null },
    },
];
